import React, { useState } from "react";
import "./ImageStep.scss";
import { Button, Col, Row, Switch } from "antd";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Gallery from "@containers/Gallery/Gallery";
import { DeleteOutlined } from "@ant-design/icons";
import { IProductForm } from "@utils/Interfaces";
import crownImg from "@assets/icons/crown.svg";

interface IImageStep {
  productForm: IProductForm;
  setProductForm: (product: any) => void;
  isSmartEstimate: boolean;
  setIsSmartEstimate: (is: boolean) => void;
}

const ImageStep: React.FC<IImageStep> = ({
  productForm,
  setProductForm,
  isSmartEstimate,
  setIsSmartEstimate,
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState<boolean>(false);

  const handleSelectImages = (images: any) => {
    const imagesArr = [...productForm.images];
    images.forEach((image: any) => {
      imagesArr.push(image.url);
    });
    setProductForm({ ...productForm, images: imagesArr });
  };

  const handleRemovePreview = (indexToRemove: number) => {
    const filteredImages = productForm.images.filter(
      (item: string, index: number) => index !== indexToRemove
    );
    setProductForm({ ...productForm, images: filteredImages });
  };

  return (
    <div className="ImageStep">
      <div className="forms-group">
        <div className="forms-title">Product Images</div>
        <div className="upload-group">
          <Row gutter={[16, 16]}>
            {Array.from({ length: 6 }).map((img, index) => {
              if (!productForm.images[index]) {                
                return (
                  <Col span={8} key={index}>
                    <div
                      className={`upload-item ${
                        productForm.images.length === index ? "" : "opacity-0"
                      }`}
                      onClick={() => setIsGalleryOpen(true)}
                    >
                      <div className="upload-icon">
                        <FontAwesomeIcon icon={faUpload} />
                      </div>
                      <div className="item-desc">
                        <span>Click to upload</span>
                      </div>
                    </div>
                  </Col>
                );
              }
              return (
                <Col span={8} key={index}>
                  <div className="img-preview-wrap">
                    <div className="img-preview-overlay">
                      <Button
                        variant="link"
                        color="danger"
                        icon={<DeleteOutlined />}
                        onClick={() => handleRemovePreview(index)}
                      />
                    </div>
                    <img
                      className="img-preview"
                      src={productForm.images[index]}
                      alt="preview"
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
          <div className="ai-checkbox-wrap">
            <div className="checkbox-content">
              <span className="content">
                <img src={crownImg} alt="crown" />
                Smart Estimation
              </span>
              <Switch
                checked={isSmartEstimate}
                onChange={(isChecked) => setIsSmartEstimate(isChecked)}
                className="ai-checkbox"
              />
            </div>
          </div>
        </div>
      </div>
      <Gallery
        isGalleryOpen={isGalleryOpen}
        cancelGallery={() => setIsGalleryOpen(false)}
        submitGallery={handleSelectImages}
        limit={6 - productForm.images.length}
        activeKey="3"
      />
    </div>
  );
};

export default ImageStep;
